var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('LimitTypeSelector',{attrs:{"config":_vm.config,"readonly":_vm.readonly}})],1),(_vm.config.limit_definition.active !== 'unlimited')?_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('TimeLimitSelector',{attrs:{"config":_vm.config,"readonly":_vm.readonly}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }